<template>
  <section class="config-group filters" aria-label="Filters">
         <div class="row stretch">
            <Checkmark checkbox-id="use-filters--i" :label="texts.filters.enabled" v-model="config.filters.enabled" hint="https://docs.sitesearch360.com/filters"/>
        </div>
        <div class="column" v-if="config.filters.enabled">
           <div class="row stretch" style="margin: 0.5em 0;" >
                <label  class="nav-1" for="nav-type--rg">{{texts.global.position}}</label>
                <RadioGroup  id="nav-type--rg" class="nav-2" :items="positionGroups" name="filter-position" @input="onPositionSet" style="margin-bottom: 0;"/>
            </div>
            <div class="row stretch" style="margin: 0.5em 0;">
                 <label for="filters-caption--i">{{texts.filters.label}}</label>
                <input id="filters-caption--i" type="text" v-model="config.filters.label" />
            </div>
            <div class="row stretch" style="margin: 0.5em 0;">
                <Checkmark checkbox-id="filter-counts--i" :label="texts.filters.showCounts" v-model="config.filters.showCounts"/>
            </div>
            <div class="row stretch" style="margin: 0.5em 0;">
                <Checkmark checkbox-id="filter-bar--i" :label="texts.filters.showQuickDeleteBar" v-model="config.filters.showQuickDelete"/>
            </div>
            <div class="row stretch" style="margin: 0.5em 0;" v-if="config.filters.showQuickDelete">
                 <label for="filters-clear--i">{{texts.filters.clearAllLabel}}</label>
                <input id="filters-clear--i" type="text" v-model="config.filters.deleteAllLabel" />
            </div>  
			<div class="row stretch" style="margin: 0.5em 0;" v-if="config.filters.position === 'left'">
                 <label for="filters-clear--i">{{texts.filters.toggleButtonLabel}}</label>
                <input id="filters-clear--i" type="text" v-model="config.filters.toggleButtonLabel" />
            </div>
        </div>
  </section>
</template>

<script>
import Vue from 'vue';
import RadioGroup from '../RadioGroup';
import Checkmark from "../Checkmark";

export default {
    name: "Filters",
    props: {
      config: {
          type: Object,
          required: true
      }
  },
  components: {RadioGroup, Checkmark},
  computed: {
    positionGroups(){
          return [
              {
                  id: "filter-left--i",
                  value: "left",
                  isActive: this.config.filters.position==='left',
                  label: this.texts.global.left
              },
              {
                  id: "filter-top--i",
                  value: "top",
                  isActive: this.config.filters.position==='top',
                  label: this.texts.global.top
              }
            
          ];
     }
  },
  methods: {
      onPositionSet(value){
          Vue.set(this.config.filters, 'position', value);
      }
  }
}
</script>

<style>
  .config-group.filters > .column{
        width: 100%;
        max-width: 500px;
    }

    .config-group.filters.active{
        display: flex;
        flex-direction: column;
        width: 100%;
        max-width: 500px;
        align-items: center;
    }

    @media(min-width: 500px){
        .config-group.filters{
            margin: 0 calc((100% - 500px)/2);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/Filters.vue